import 'jquery.cookie';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';

let popup = {};

(function (popupApp) {
	let filterModel = {
		PopupAmountOfTimeOnSite: 0,
		PopupAmountOfPagesVisited: 0,
		PreventPopupFromShowing: false
	};

	popupApp.GetPopupResult = function () {
		$.ajax({
			url: "/umbraco/surface/PopupSurface/GetPopupResult",
			type: "POST",
			data: filterModel,
			dataType: "json",
			success: function (data) {
				if (data.showPopUp) {
					displayPopup(data.popUpDelayTime);
				}
			},
			error: function (XMLHttpRequest, textStatus, errorThrown) {
				console.log("XMLHttpRequest: ", XMLHttpRequest);
				console.log("textStatus: ", textStatus);
				console.log("errorThrown: ", errorThrown);
			}
		});
	};

	function displayPopup(popUpTimeOut) {
		const expiredDays = parseInt($("#signup-pop-up").data("expirydays"));
		const cookieName = $("#signup-pop-up").data("cookie");
		const delay = popUpTimeOut * 1000;

		//only execute code if cookie not set. Home page caches html, so could still hold popup html even though popup has been displayed
		if (typeof $.cookie(cookieName) === 'undefined') {
			setTimeout(
				function () {
					$.fancybox.open({
						src: '#signup-pop-up',
						touch: false
					});
					$.cookie(cookieName, true, { expires: expiredDays, path: '/' });
				}, delay);
		}
	}

	$(document).ready(function () {

		if (document.querySelector("#signup-pop-up")) {

			filterModel.PopupAmountOfPagesVisited = parseInt($("#signup-pop-up").data("popupamountofpagesvisited"));
			filterModel.PopupAmountOfTimeOnSite = parseInt($("#signup-pop-up").data("popupamountoftimeonsite"));
			filterModel.PreventPopupFromShowing = $("#signup-pop-up").data("preventpopupfromshowing");
			popupApp.GetPopupResult();
		}

	});

})(popup);
